<template>
  <div id="top-header">
    <dv-decoration-8 class="header-left-decoration" />
    <dv-decoration-5 class="header-center-decoration" />
    <dv-decoration-8 class="header-right-decoration" :reverse="true" />
    <div class="center-title">宿舍归寝数据展板</div>
    <div class="time">{{ currentTime }}</div>
  </div>
</template>

<script>
  export default {
    name: 'TopHeader',
    data() {
      return {
        currentTime: '',
      };
    },
    created() {
      this.updateTime();
    },
    beforeDestroy() {
      // 清除定时器
      clearTimeout(this.updateTime);
    },
    methods: {
      // 更新时间
      updateTime() {
        this.currentTime = this.$util.toDateString(new Date(), 'yyyy-MM-dd HH:mm:ss');
        setTimeout(this.updateTime, 1000);
      },
    },
  };
</script>

<style lang="scss">
  #top-header {
    position: relative;
    width: 100%;
    height: 100px;
    display: flex;
    justify-content: space-between;
    flex-shrink: 0;

    .header-center-decoration {
      width: 40%;
      height: 60px;
      margin-top: 30px;
    }

    .header-left-decoration,
    .header-right-decoration {
      width: 25%;
      height: 60px;
    }

    .center-title {
      position: absolute;
      font-size: 30px;
      font-weight: bold;
      left: 50%;
      top: 15px;
      transform: translateX(-50%);
    }
    .time {
      position: absolute;
      font-size: 20px;
      font-weight: bold;
      left: 68%;
      top: 50px;
      transform: translateX(-50%);
    }
  }
</style>
